import classNames from 'classnames'
import React from 'react'
import { isNullOrWhiteSpace } from '../../utilities/string'
import { AnnualReviewsBox, Review } from '../AnnualReviewsBox'
import { Grid } from '../Grid'

export interface AnnualReviewsNewDesignProps {
  reviews?: Review[]
  title?: string
}

export const AnnualReviewsNewDesign = ({
  reviews,
  title,
}: AnnualReviewsNewDesignProps) => (
  <Grid>
    <div
      className={classNames(
        'col-span-full',
        'sm:mx-120',
        'md:mx-0',
        'lg:col-start-2 lg:col-span-6 lg:-mx-75',
        'xl:col-start-2 xl:col-span-8 xl:-mx-45',
        'xxl:col-start-4 xxl:col-span-8'
      )}
    >
      {!isNullOrWhiteSpace(title) && (
        <h2 className="mb-45 font-h2 text-h2 text-secondary-dark">{title}</h2>
      )}

      {!!reviews?.length && (
        <div className="flex flex-col gap-30 tb:flex-row tb:flex-wrap lg:gap-90">
          {reviews.map((review, index) => (
            <div
              className="tb:basis-[calc(50%-15px)] lg:basis-[calc(50%-45px)]"
              key={index}
            >
              <AnnualReviewsBox review={review} />
            </div>
          ))}
        </div>
      )}
    </div>
  </Grid>
)
